// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PoseTile_wrapper__6illr","main":"PoseTile_main___WsW_","headline":"PoseTile_headline__IPwiU"};